export default function buildGetPublicProducerApplications({
    apiEndpoint,
    apiTools
}) {
    return async function getPublicProducerApplications(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/public`
        })
       
        const res = await fetch(url, {
            method: 'GET',
            credentials: 'include',
        });
        return await res.json();
    }
}